import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import UserFeedback from "@views/user/bid-entry/components/UserFeedback.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'MobileEmployeeNavigation',
  setup(__props, { expose: __expose }) {
  __expose();

const showUserFeedback = ref(false);
const route = useRoute();
const router = useRouter();
const activeNavigation = computed(() => (showUserFeedback.value ? "feedback" : route.name));
const buttonDefaults = {
  VBtn: {
    variant: "plain",
    class: "pa-1 font-weight-medium opacity-100",
    ripple: false,
  },
};

function navigateTo(routeName: "work-schedule" | "bid-entry") {
  showUserFeedback.value = false;
  router.push({ name: routeName });
}

const __returned__ = { showUserFeedback, route, router, activeNavigation, buttonDefaults, navigateTo, UserFeedback }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})